import $ from 'jquery';

import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';
import Validation from '../classes/Validation';
import Vars from '../../vars';

class Promocode {
    constructor (args) {
        let self = this;

        self._setArgs(args);
        self._init();
    };

    _elems = {
        $content : $(),
        $create  : $()
    };

    _const = {
        entities : 'promocodes',
        entity   : 'promocode',
        id       : 'id',
        title : {
            add  : 'Добавление нового промокода'
        }
    };

    _args = {
        page : ''
    };

    _state = {
        modal      : {},
        fields     : {},
        item       : {},
        items      : {}
    };

    _utils = {
        validation : {}
    };

    _setArgs = (args) => {
        let self = this;

        self._args.page   = args.page;
        self._args.title  = args.title;
    };

    _setFields = () => {
        let self = this;

        self._state.fields = {};
    };

    _setValidation = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._utils.validation = new Validation({
            form : self._elems.$form
        });
    };

    _initModal = () => {
        let self = this;

        self._setFields();

        loader.increase();

        let queue = [];
        if (Object.keys(self._state.item).length) {
            queue.push({
                path : '/api/' + self._const.entities + '/' + (Object.keys(self._state.item).length ? self._state.item[self._const.id]: self._args.prefix + '_' + self._args.suffix)
            });
        }
        queue.push({
            path : '/api/' + self._const.entities + '/options'
        });

        Request.send({
            queue : queue,
            done : function(response, extraResponse) {
                loader.decrease();

                self._state.item = Object.keys(self._state.item).length ? response[self._const.entity] : {};

                const options    = Object.keys(self._state.item).length ? extraResponse.options : response.options;

                self._elems.$modal = new Modal({
                    title : self._state.item ? self._const.title.edit : self._const.title.add,
                    closingConfirmation : true,
                    confirm : function(args){
                        self._bindSubmit(args);
                    },
                    content: Utils.renderProfileTemplate(self._const.entity + '-form', {
                        [self._const.entity] : Object.keys(self._state.item).length ? self._state.item : null,
                        fields               : self._state.fields,

                        options              : options,
                        ad_types             : response.ad_types,
                        buildings            : response.buildings,
                        building_ids         : response.building_ids,
                        sections             : response.sections,
                        section_ids          : response.section_ids,
                        section_show_ids     : response.section_show_ids,
                        object_ids           : response.object_ids,

                        buttons  : {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Сохранить',
                                type  : 'submit'
                            },
                            two : {
                                class : 'button--cancel',
                                title : 'Отмена'
                            }
                        }
                    })
                });
                
                self._elems.$form = self._elems.$modal.find('form');

                self._setValidation();
            }
        });
    };

    _bindSubmit = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        const errors = $form.find('.form-field.error').length;

        if(errors) return;

        loader.increase();

        Request.send({
            path   : '/api/' + self._const.entities + '/' + (Object.keys(self._state.item).length ? self._state.item[self._const.id] + '/edit' : 'create'),
            method : 'POST',
            data   : $form.serialize(),

            done: function(response) {
                loader.decrease();

                if (response.error) {
                    self._utils.validation.showErrors(response.error);
                    return
                }

                self._state.item  = response[self._const.entity];
                self._state.items = {};

                $modal.trigger('close');

                if(self._args.mode === Vars.view.index || self._args.mode === Vars.view.list) {
                    window.location.href = '#' + self._const.entities + '/' + self._state.item.feed_id;
                }
            }
        });
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if(!self._elems.$content.length) return;
    };

    _bindUI = () => {
        let self = this;

        self._elems.$create.length && self._elems.$create.unbind('click').on('click', function(e) {
            e.preventDefault();

            self._initModal();
        });
    };

    _list = () => {
        let self = this;

        self._bindElements();

        Request.send({
            path: '/api/' + self._const.entities,
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items   = response[self._const.entities] ? response[self._const.entities] : {};

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : self._args.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                    breadcrumbs            : self._state.breadcrumbs,
                    [self._const.entities] : self._state.items
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _init = () => {
        let self = this
        if (self._args.page === Vars.page.list) {
            self._list();
        }
    };
}

export default Promocode;